import { __extends } from "tslib";
import { DeleteObjectTaggingOutput, DeleteObjectTaggingRequest } from "../models/index";
import { deserializeAws_restXmlDeleteObjectTaggingCommand, serializeAws_restXmlDeleteObjectTaggingCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteObjectTaggingCommand = /** @class */ (function (_super) {
    __extends(DeleteObjectTaggingCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteObjectTaggingCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteObjectTaggingCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: DeleteObjectTaggingRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DeleteObjectTaggingOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteObjectTaggingCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlDeleteObjectTaggingCommand(input, context);
    };
    DeleteObjectTaggingCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlDeleteObjectTaggingCommand(output, context);
    };
    return DeleteObjectTaggingCommand;
}($Command));
export { DeleteObjectTaggingCommand };
//# sourceMappingURL=DeleteObjectTaggingCommand.js.map